import { Status } from '@prometheus/types';

import { UseCdmDataSourceInterface } from './useDataSourceList.types';

export const INITIAL_STATE: UseCdmDataSourceInterface = {
  status: Status.INITIAL,
  list: [],
  error: null,
};
